require('./hireCardVirtualOnlyDebitError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const { catalogue, analyticsId } = require('../analytics/hireCardVirtualOnlyDebitAnalytics');

class HireCardVirtualOnlyDebitError extends React.Component {
    buildTexts() {
        const { immHireCardVirtualOnlyDebit, hireRestrictionFlag } = this.props;
        let errorMsg = immHireCardVirtualOnlyDebit.get('errorMsg');

        let titleKey;
        let textElement;

        if (!!errorMsg) {
            titleKey = 'hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_errorTitleNotAllowed';
            textElement = <FormattedText value={`hireDebitErrors-${errorMsg}`} />;
        } else {
            titleKey = 'hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_errorTitleGeneric';
            textElement = <FormattedText value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_errorTextGeneric" />;
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />;
        }

        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { processDetail, hireRestrictionFlag } = this.props;
        const { textElement, titleKey } = this.buildTexts();
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        } : {
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_errorBackButtonText"
                />
            ),
            url: '/myprofile/cards'
        };
        const cancleButton ={
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionCancleButtonText"
                />
            ),
            url: '/myprofile/cards'
            };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.VIRTUAL_ONLY_DEBIT_CARD_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-card-virtual-only-debit-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

HireCardVirtualOnlyDebitError.propTypes = {
    immHireCardVirtualOnlyDebit: PropTypes.object.isRequired,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

HireCardVirtualOnlyDebitError.defaultProps =
{
    hireRestrictionFlag : false
}

module.exports = HireCardVirtualOnlyDebitError;
